import { render, staticRenderFns } from "./border-box.vue?vue&type=template&id=4cf43d6e&scoped=true"
import script from "./border-box.vue?vue&type=script&lang=js"
export * from "./border-box.vue?vue&type=script&lang=js"
import style0 from "./border-box.vue?vue&type=style&index=0&id=4cf43d6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf43d6e",
  null
  
)

export default component.exports